import { StorageObjectValue } from "../../../services/api/instances/storageApi/types/service_types";
import { MenuItem } from "../types";

export function searchInValue(
  value: StorageObjectValue,
  query: string
): boolean {
  const normalizedQuery = normalizeString(query);
  const valueStr = JSON.stringify(value) || "";
  return normalizeString(valueStr).includes(normalizedQuery);
}

export function normalizeString(str: string): string {
  return str.toLowerCase().replace(/[^a-zа-я0-9]/g, "");
}

export function getSortResult(item: MenuItem, search: string): number {
  const normalizedSearch = normalizeString(search);
  const name = normalizeString(item.name);

  if (search === "") return 0;

  if (name === normalizedSearch) {
    return 4;
  }

  if (name.startsWith(normalizedSearch)) {
    return 3;
  }

  const index = name.indexOf(normalizedSearch);
  if (index !== -1) {
    return 2 + 1 / (index + 1);
  }

  if (searchInValue(item?.value as StorageObjectValue, search)) {
    return 1;
  }

  return 0;
}
